import React, { useState } from 'react';
// components
import {Col, Row,} from "react-bootstrap";
//style
import './style.css'

import TextLoader from '../../components/TextLoader/TextLoader';

import { useAppStore } from "../../context/state";

const ShoppingCart = ({items=[], lang}) => {
  const books = useAppStore((state) => state.shopingCart)
  const sortBooks = useAppStore((state) => state.sortBook)
  const removeBooks = useAppStore((state) => state.removeBook)
  const updateBook = useAppStore((state) => state.updateBook)
  
  // eslint-disable-next-line no-unused-vars
  const [loading, setLoading] = useState(true)

  let cantidad = books.length
  let envio = cantidad === 0 ? 0 : 10000

  function changeQTY(value, book) {
    if(value === "0"){
      removeBooks(book._id)
      return;
    }else{
      updateBook({...book, qty: +value})
    }
  }

  const onChangeOrder =(item)=>{
    const fun = {
      "default":(a, b) => (a.title - b.title)?1:-1,
      "sortByPriceAsc": (a,b)=> (a.price > b.price)? 1:-1,
      "sortByPriceDes": (a,b)=> (a.price > b.price)? -1:1,
      "sortByQuantityAsc":(a,b)=> {
        console.log(">>>", a.title, a.qty, " <<< ",b.title, b.qty)
        return (a.qty > b.qty)? -1:1
      },
      "sortByQuantityDes":(a,b)=> {
        console.log(">>>", a.title, a.qty, " <<< ",b.title, b.qty)
        return (a.qty > b.qty)? 1:-1
      }
    }[item]
    sortBooks(fun)
  }

  return(
    <>
    <Row>
      <Col md={8} sm={12}>

      <div className="card" style={{ minHeight:'100vh'}}>
      <div className="card-header border-0">
        <div className="d-flex justify-content-between">
          <span>{lang.cart_itemlist} {cantidad}</span>
            <div className="d-flex flex-row align-items-center">
              <span className="text-black-50 px-2">{lang.cart_orderby}</span>
              <select 
                className="form-control-sm px-1" onChange={e => onChangeOrder(e.target.value)}
                defaultValue='default'>

                <option value='default'>Seleccionar opción</option>
                <option value='sortByPriceAsc' >{lang.cart_sort_price_asc}</option>
                <option value='sortByPriceDes' >{lang.cart_sort_price_des}</option>
                <option value='sortByQuantityAsc' >{lang.cart_sort_quantity_asc}</option>
                <option value='sortByQuantityDes' >{lang.cart_sort_quantity_des}</option>
              </select>
            </div>
        </div>
      </div>
      <div className="card-body border-0">
        {!loading?(
            <TextLoader
              upperMessage={'Cargando'} //lang.author.loading.books_upper}
              lowerMessage={'Estamos obteniendo el carrito'} //lang.author.loading.books_lower}
            />
        ):(
          <table className='table-responive w-100'>
            <thead>
              <tr>
                <th></th>
                <th>Cantidad</th>
                <th>Valor</th>
              </tr>
            </thead>
            <tbody>
              {
                books.map((book) =>{
                  return(
                    <tr key={book._id}>
                      <td>
                        <div className="d-flex flex-row">
                          <div style={{ minWidth:'20%', display:'flex', justifyContent:'center' }}>
                            <img className="rounded" src={book.coverImage} height="100" alt='Portada del libro'/>
                          </div>
                          <div className="m-2">
                            <p>
                              <strong className="font-weight-bold d-block">{book.title.toUpperCase()}</strong>
                              {book.collaborators.map((author, idx) => {
                                return(
                                  <span key={idx} className="text-sm text-secondary">{ author }<br/></span>
                                )
                              })}
                              (<a href={`/editorial/books/${book._id}`}> Ver más</a>)
                            </p>
                          </div>
                        </div>
                      </td>
                      <td>
                      { book.qty < 9 && 
                        <select className="form-control-sm px-1 " style={{width:"50%"}} 
                          onChange={(e)=> changeQTY(e.target.value, book)}
                          value={book.qty} >
                          <option value={0} >0 Eliminar</option>
                          {
                            [1,2,3,4,5,6,7,8].map(value=>{
                              return (<option key={value} value={value} >{value}</option>)
                            })
                          }
                          <option value={9} >más</option>
                        </select> }
                      { book.qty > 8 &&
                        <input type='number' maxLength='4' size='4' 
                        onChange={(e)=> changeQTY(e.target.value, book)}
                        value={book.qty} style={{width:"50%"}}  />
                      }
                      </td>
                      <td>$ {book.qty * book.price}</td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        )}
      </div>

      



        {/* {books? books.map((book) =>        
                <div key={book._id} className="d-flex justify-content-between align-items-center mt-3 p-2 items rounded">
                <div className="d-flex flex-row">
                  <img className="rounded" src={book.coverImage} height="100" alt='Portada del libro'/>
                  <div className="m-2">
                    <h5 className="font-weight-bold d-block">{book.title}</h5>
                    {book.authors.map(author => <span key={author.lastName + author.firstName} className="spec">{author.lastName} {author.firstName}</span>)}

                  </div>
                </div>
                <div className="d-flex flex-row align-items-center">
                  <span className="d-block">
                    <select className="form-control-sm p-0" defaultValue={book.qty} >
                      <option onClick={()=> removeBooks(book._id)} value={0}>0 Eliminar</option>
                      <option onClick={(e)=> changeQTY(e.target.value, book)} value={1}>1</option>
                      <option onClick={(e)=> changeQTY(e.target.value, book)} value={2}>2</option>
                      <option onClick={(e)=> changeQTY(e.target.value, book)} value={3}>3</option>
                      <option onClick={(e)=> changeQTY(e.target.value, book)} value={4}>4</option>
                    </select>
                  </span>
                  <span className="d-block ml-5 font-weight-bold">{' '}${book.price.toLocaleString('es-CO')}</span>
                  <i className="fa fa-trash-o ml-3 text-black-50"></i>
                </div>
              </div>
            )
            :(

            )
        } */}

      </div>


      </Col>
      <Col md={4} sm={12}>

        <div className="card">
          <div className="card-header border-0">
            {lang.cart_details} ({cantidad} {lang.cart_item})
          </div>
          <div className="card-body">
            <p className='text-end'>{lang.cart_subtotal}: {lang.cart_coin} {books.reduce((a, c) => a + c.price * c.qty, 0).toLocaleString('es-CO')}</p>
            <p className='text-end'>{lang.cart_shipping}: {lang.cart_coin} {envio.toLocaleString('es-CO')} </p>
            <p className='text-end'>{lang.cart_total}: {lang.cart_coin} {books.reduce((a, c) => a + c.price * c.qty, envio).toLocaleString('es-CO')}</p>
            <p><a href="#" className="btn btn-primary btn-block">{lang.cart_btnpay}</a></p>
          </div>
        </div>

      </Col>
    </Row>
    </>
  );
};

export default ShoppingCart;
